/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/ServiceEndpointFinalizeDraftDetailsComponent" />
import * as React from "react";

import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import { ServiceEndpointActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointActionsCreator";
import {
    IServiceEndpointComponentState,
    ServiceEndpointStore
} from "DistributedTaskUI/ServiceEndpoints/Details/Stores/ServiceEndpointStore";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { copyToClipboard } from "VSSUI/Clipboard";
import * as Utils_String from "VSS/Core/Util/String";
import { Location } from "VSSUI/Utilities/Position";
import { Card } from "VSSUI/Card";
import { TitleSize } from "VSSUI/Header";
import { Button } from "VSSUI/Button";

export interface IServiceEndpointFinalizeDraftDetailsComponentProps { }

enum CopiedItem {
    SUBJECT = "subject",
    ISSUER = "issuer"
}

export class ServiceEndpointFinalizeDraftDetailsComponent extends VssComponent<IServiceEndpointFinalizeDraftDetailsComponentProps, IServiceEndpointComponentState> {
    constructor(props: IServiceEndpointFinalizeDraftDetailsComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._actionCreator = ActionCreatorManager.GetActionCreator<ServiceEndpointActionsCreator>(
            ServiceEndpointActionsCreator,
            "service-endpoints-section-actionscreator"
        );
        this._store = StoreManager.GetStore<ServiceEndpointStore>(ServiceEndpointStore, ServiceEndpointStore.getKey());
        this.state = ServiceEndpointStore.getDefaultState();
    }

    public UNSAFE_componentWillMount(): void {
        this.setState(this._store.getState());
    }

    public componentDidMount(): void {
        this._store.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        this._store.removeChangedListener(this._onStoreChanged);
    }

    private _onStoreChanged = (): void => {
        this.setState(this._store.getState());
    }

    public render(): React.ReactNode {
        if (!Utils_String.equals(this.state.serviceEndpoint.data[EndpointConstants.AzureEndpointConstants.IsDraft], "true", true)) {
            return null;
        }

        return <Card
                className="service-connection-details-card flex-column margin-top-16"
                contentProps={{ contentPadding: false }}
                titleProps={{
                    size: TitleSize.Medium,
                    text: Resources.FinalizeDraftCardTitle
                }}
            >
                <div className="flex-grow service-connection-details-container">
                    <div className="details-content-data">
                        <div className="sc-details-table">
                            <div className="sc-data-label secondary-text">{Resources.WorkloadIdentityFederationIssuer}:</div>
                            <div className="sc-data-value">
                                {this.state.oidcFederationIssuer}
                                {this._renderCopyButton(CopiedItem.ISSUER, () => this._copyFederationIssuer())}
                            </div>
                            <div className="sc-data-label secondary-text">{Resources.WorkloadIdentityFederationSubject}:</div>
                            <div className="sc-data-value">
                                {this.state.oidcFederationSubject}
                                {this._renderCopyButton(CopiedItem.SUBJECT, () => this._copyFederationSubject())}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>;
    }

    private _renderCopyButton(item: CopiedItem, onCopy: () => void): React.ReactNode {
        return (
            <Button
                subtle={true}
                ariaLabel={Resources.ClipboardCopy}
                iconProps={{ iconName: "Copy" }}
                onClick={onCopy}
                tooltipProps={{
                    anchorOffset: { horizontal: 0, vertical: 0 },
                    anchorOrigin: { horizontal: Location.center, vertical: Location.start },
                    text: this.state.itemCopiedToClipboard === item ? Resources.ClipboardCopyTooltipCopied : Resources.ClipboardCopyTooltip,
                    tooltipOrigin: { horizontal: Location.center, vertical: Location.end }
                }}
            />
        );
    }

    private _copyFederationSubject() {
        copyToClipboard(this.state.oidcFederationSubject);

        this.setState({
            itemCopiedToClipboard: CopiedItem.SUBJECT
        });
    }

    private _copyFederationIssuer() {
        copyToClipboard(this.state.oidcFederationIssuer);

        this.setState({
            itemCopiedToClipboard: CopiedItem.ISSUER
        });
    }

    private _actionCreator: ServiceEndpointActionsCreator;
    private _store: ServiceEndpointStore;
}
